export enum HTTPRequestStatuses {
	idle = 'idle',
	pending = 'pending',
	success = 'success',
	failed = 'failed',
}
